//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  data() {
    return {
      unidadeMedidaResources: this.$api.unidadeMedida(this.$resource),
      lista: [],
      esperar: false,
      totalPage: 0,
      headers: [
        { text: this.$tc('label.sigla', 1), value: 'sigla', sortable: false },
        { text: this.$tc('label.nome', 1), value: 'nome', sortable: false },
        { text: '', value: 'acoes', sortable: false },
      ],
      pagination: {},
      searchQuery: '',
    };
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  props: {
    title: String,
  },
  computed: {
    ...generateComputed('unid medida', [
      'canAccessCRUD',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    buscar() {
      if (this.searchQuery) {
        this.pagination.page = 1;
      }

      const params = {
        nome: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };

      this.unidadeMedidaResources.listar(params).then((response) => {
        this.lista = response.data.resposta;
        this.totalPage = response.data.quantidadeRegistrosPagina;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    getSearchQuery() {
      return this.searchQuery;
    },
    onEditar(unidade) {
      this.$emit('PESQUISA_UNIDADE_EDITAR', unidade);
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/unidade-medida/UnidadeMedidaLista.vue?vue&type=script&lang=js&